module.exports = __webpack_public_path__ + "img/celebrate.1b5a468f.jpg";